<template>
  <div>
    <div v-if='type == "login"'>
     <loginpage :routerAddress ='routerAddress'  :address ='address'></loginpage>
    </div>
    <div  v-if='type == "register"' >
        <registerpage></registerpage>
  </div>
  </div>
</template>
<style lang="">
  
</style>
<script>
import loginpage from "./register/loginpage";
import registerpage from "./register/registerpage";
export default {
  components: {
    loginpage,
    registerpage
  },
  data(){
    return {
      login_source:'',
      routerAddress:'',
      // entrance:'',
      address:'',
      type:''
    }
  },
  created(){
    // 当在首页部分点击提报系统时获取当时的路由地址
    if(this.$router.history.current.query.code && this.$router.history.current.query.code == 401){
      this.routerAddress = this.$router.history.current.query.redirect; 
      this.type = 'login' 
    }
  },
  mounted(){
    // 判断从tibao服务的哪个页面跳转过来
     if(window.location.hash.indexOf('?') != -1){
        let str= window.location.hash.split('?')[1];
        let arr= str.split('&');
        for(let i = 0 ;i <arr.length;i++){
          let tmp = arr[i].split('=')[0] 
          if(tmp == 'address'){
            let address = arr[i].split('=')[1];
            this.address = decodeURIComponent(address) 
          }else if(tmp == 'routerAddress'){
            this.routerAddress = decodeURIComponent(arr[i].split('=')[1]);
          }
          else if(tmp == 'type'){
            let type = arr[i].split('=')[1]; 
            this.type = type 
          }
          // else if(tmp == 'entrance'){
          //   this.entrance = arr[i].split('=')[1];
          // }
        } 
     }

  },
  methods: {
  }
}
</script>
